module.exports = __webpack_public_path__ + "static/media/icon-coins.2078bee5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/icon-coins.svg
// module id = 993
// module chunks = 0